// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","443":"about"}[chunkId] || chunkId) + "." + {"36":"b1d2691b","177":"88e97314","443":"bfc2701a"}[chunkId] + ".js";
};